import React from "react";
import extractSrcFromIframe from "../../../../utils/extractSrcFromIframe";
import Divider from "./Divider";

const EventMap = ({ venueMap }) => {
  // Helper: Extract URL whether venueMap is an iframe string or direct URL
  const getMapSrc = (mapData) => {
    if (!mapData) return null;
    
    // If it looks like an iframe HTML string, extract the src
    if (typeof mapData === "string" && mapData.trim().startsWith("<iframe")) {
      return extractSrcFromIframe(mapData);
    }
    
    // If it's already a URL (http/https or embed URL), return as-is
    if (typeof mapData === "string" && (mapData.startsWith("http") || mapData.startsWith("//"))) {
      return mapData;
    }
    
    // Fallback: try to extract anyway
    return extractSrcFromIframe(mapData);
  };

  const embedMapURL = getMapSrc(venueMap);

  return (
    <>
      <h1
        id="location"
        className="d-flex justify-content-center"
        style={{ color: "black", fontWeight: "bold" }}
      >
        Event Location
      </h1>
      <Divider />
      <div 
        className="w-100 mt-4" 
        style={{ 
          height: "400px", 
          backgroundColor: "#f8f9fa", 
          borderRadius: "8px", 
          overflow: "hidden" 
        }}
      >
        {embedMapURL ? (
          <iframe
            src={embedMapURL}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Event Location Map"
          ></iframe>
        ) : (
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            height: "100%", 
            color: "#666",
            flexDirection: "column",
            gap: "12px",
            padding: "20px",
            textAlign: "center"
          }}>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="48" 
              height="48" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="1.5"
              style={{ opacity: 0.6 }}
            >
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
            <p style={{ margin: 0, fontSize: "14px" }}>
              {venueMap ? "Invalid map format" : "No location set"}
            </p>
            {venueMap && (
              <small style={{ color: "#999", fontSize: "12px" }}>
                Please update the event location in the builder
              </small>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default EventMap;